import * as React from "react";

interface ShowingProps {
    currentPage: number;
    pageSize: number;
    total: number;
    dataCy?: string;
}

export const Showing = (props: ShowingProps) => {
    const total = props.total;
    const begin = (props.currentPage - 1) * props.pageSize + 1;
    const dataCy = props.dataCy;

    let end = begin + props.pageSize - 1;
    if (end > total) {
        end = total;
    }

    if (begin > total || total < 1) {
        return null;
    } else {
        return (
            <div className="c-showing" data-cy={dataCy}>
                Showing {begin}-{end} of <span id="totalResults">{total}</span>
            </div>
        );
    }
};

export default Showing;
